var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DocumentBodyState from '@/helpers/window/DocumentBodyState';
import { useTopPageFetchCase } from '@/hooks/pages/top/useTopPageFetchCase';
import { useTopPageFetchTheme } from '@/hooks/pages/top/useTopPageFetchTheme';
import { ProfessionalTopPage } from '@/pages/top/ProfessionalTop/ProfessionalTopPage';
/**
 * コンサルタント向けTOPページ（データ取得, 認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const ProfessionalTop = () => {
    const dispatch = useDispatch();
    // body からデータを取得
    const { news: { dataList: newsList }, professional: { totalCount: professionalCount }, rfp: { totalCount: rfpCount }, } = DocumentBodyState.attributes;
    // テーマの情報取得
    const { fetchTheme, themeList } = useTopPageFetchTheme({ dispatch });
    // 選定支援事例の情報取得
    const { caseList, fetchCase } = useTopPageFetchCase({ dispatch });
    // データ取得
    useEffect(() => {
        // 全てのデータがある場合 取得処理を走らせない
        if (themeList && caseList) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const apis = [];
            if (!themeList) {
                apis.push(fetchTheme());
            }
            if (!caseList) {
                apis.push(fetchCase());
            }
            // apiを実行してデータを取得
            yield Promise.all(apis);
        }))();
    }, [caseList, fetchCase, fetchTheme, themeList]);
    return (_jsx(ProfessionalTopPage, { caseList: caseList, newsList: newsList, professionalCount: professionalCount, rfpCount: rfpCount, themeList: themeList }));
};
